import { MessageSquare } from 'lucide-react'
import { t } from '@/shared/lib/i18n'

interface CommentCountIndicatorProps {
  count: number
}

/**
 * Comment count on a result row: speech-bubble icon plus the number, labelled "Comments: N".
 * Shared by the Reports list (REBUILD-606) and the Maintenance Logs history (REBUILD-622) so both
 * surfaces keep the same icon, count format, accessible label and 0 / 1 / many handling.
 * Renders nothing when there are no comments.
 */
export const CommentCountIndicator = ({ count }: CommentCountIndicatorProps) => {
  if (count <= 0) return null

  const label = t('common.commentCountAria', { count })
  return (
    <span
      className="inline-flex shrink-0 items-center gap-0.5 text-muted-foreground"
      role="img"
      aria-label={label}
      title={label}
    >
      <MessageSquare className="h-3 w-3" aria-hidden />
      <span>{count}</span>
    </span>
  )
}
